import React from 'react';
import PropTypes from 'prop-types';
import { Typography } from '@material-ui/core';

export default function Title(props) {
  return (
    <Typography component="h1" variant="h6" color="primary" style={{textTransform:"uppercase"}} gutterBottom>
      {props.children}
    </Typography>
  );
}

Title.propTypes = {
  children: PropTypes.node,
};
